export default {"src":"/_next/static/media/info.8174d6bc.svg","height":20,"width":20};